module.exports = {"520381001":"市中街道","520381002":"文华街道","520381003":"金华街道","520381100":"天台镇","520381101":"复兴镇","520381102":"大同镇","520381103":"旺隆镇","520381104":"葫市镇","520381105":"元厚镇","520381106":"官渡镇","520381107":"长期镇","520381108":"长沙镇","520381109":"两河口镇","520381110":"丙安镇","520381202":"宝源乡","520381203":"石堡乡","520381204":"白云乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520381.json
// module id = 2608
// module chunks = 0